/* eslint-disable max-len */
/* eslint-disable no-nested-ternary */
import { h, render, Fragment } from 'preact';
import {
  useState,
  useEffect,
  useCallback,
  useLayoutEffect,
} from 'preact/hooks';
import { useWindowSize } from '../utils/window-size';
import Video from '../utils/vimeoPlayer';
import Accordion from '../utils/accordion';
import Image from '../utils/image';

export default (element) => {
  const init = async () => {
    render(<Highlight />, element);
  };

  const Highlight = () => {
    const formatHighlightData = (data) => {
      // eslint-disable-next-line prefer-const
      let formattedHighlight = [];
      let isEmpty = true;
      // eslint-disable-next-line array-callback-return
      data?.highlightMetafields.map((item) => {
        if (item) {
          if (item.reference) {
            formattedHighlight[item.key] = item.reference.image.originalSrc;
          } else {
            formattedHighlight[item.key] = item.value;
          }
          isEmpty = false;
        }
      });
      return isEmpty ? null : formattedHighlight;
    };

    const formatAccordions = (data) => {
      // eslint-disable-next-line prefer-const
      let formattedAccordions = [];
      let isEmpty = true;
      if (data) {
        Array.from(Array(4).keys()).forEach((el) => {
          // eslint-disable-next-line prefer-const
          let accordionInfo = [];
          if (data[`heading_${el + 1}`] === undefined) {
            return;
          }
          accordionInfo.heading = data[`heading_${el + 1}`];
          accordionInfo.content = data[`content_${el + 1}`];
          accordionInfo.cta_text = data[`cta_text_${el + 1}`];
          accordionInfo.url = data[`url_${el + 1}`];
          formattedAccordions.push(accordionInfo);
        });
        isEmpty = false;
      }
      return isEmpty ? null : formattedAccordions;
    };

    const [currentProduct, setCurrentProduct] = useState(null);
    const { isTablet } = useWindowSize();
    const [vimeoPlayer, setVimeoPlayer] = useState(null);
    const [activeAccordions, setActiveAccordions] = useState([0]);
    const highlightData = formatHighlightData(currentProduct);
    const accordions = formatAccordions(highlightData);

    const imageDesktop =
      highlightData && highlightData.desktop_image
        ? highlightData.desktop_image
        : null;
    const imageMobile =
      highlightData && highlightData.mobile_image
        ? highlightData.mobile_image
        : null;
    // eslint-disable-next-line no-nested-ternary
    const videoIdDesktop =
      highlightData && highlightData.desktop_video
        ? highlightData.desktop_video.includes('https://vimeo.com/')
          ? highlightData.desktop_video.split('https://vimeo.com/')[1]
          : highlightData.desktop_video
        : null;
    // eslint-disable-next-line no-nested-ternary
    const videoIdMobile =
      highlightData && highlightData.mobile_video
        ? highlightData.mobile_video.includes('https://vimeo.com/')
          ? highlightData.mobile_video.split('https://vimeo.com/')[1]
          : highlightData.mobile_video
        : null;
    const videoUrlDesktop =
      highlightData && highlightData.desktop_video
        ? highlightData.desktop_video
        : null;
    const videoUrlMobile =
      highlightData && highlightData.mobile_video
        ? highlightData.mobile_video
        : null;

    const onPlayerInit = useCallback((player) => {
      setVimeoPlayer(player);
    }, []);

    useEffect(() => {
      document.addEventListener('product:updated', (e) => {
        setCurrentProduct(e.detail.payload.product);
      });

      document.addEventListener('product:init', (e) => {
        setCurrentProduct(e.detail.payload.product);
      });
    }, []);

    useLayoutEffect(() => {
      vimeoPlayer?.play();
    }, [vimeoPlayer, currentProduct]);

    return (
      <>
        {((accordions && accordions.length > 0) ||
          videoIdDesktop ||
          imageDesktop ||
          videoIdMobile ||
          imageMobile) && (
          <div className="relative laptop:block flex flex-col-reverse py-5 laptop:p-10">
            <div
              className={`${
                isTablet ? 'bg-[#222222]' : 'bg-[rgba(0,0,0,0.6)]'
              } laptop:z-[1] laptop:absolute laptop:right-[83px] laptop:top-[50%] laptop:-translate-y-2/4 
                   laptop:drop-shadow-[-10px 10px 49px rgba(0, 0, 0, 0.15)] w-full laptop:max-w-[480px]
                   -mt-px laptop:mt-0`}
            >
              {accordions && accordions.length > 0 && (
                <div
                  className={`pt-[10px] laptop:pt-[40px] pb-[24px] px-5 laptop:px-10 ${
                    // eslint-disable-next-line no-nested-ternary
                    isTablet ? null : videoIdDesktop ? null : 'backdrop-blur-sm'
                  }`}
                >
                  {accordions.map((accordion, index) => (
                    <Accordion
                      key={index}
                      data={accordion}
                      index={index}
                      activeAccordions={activeAccordions}
                      setActiveAccordions={setActiveAccordions}
                    />
                  ))}
                </div>
              )}
            </div>
            <div className="relative">
              {!isTablet ? (
                videoIdDesktop ? (
                  <div className="highlight_video laptop:mb-7">
                    <Video
                      url={videoUrlDesktop}
                      id={videoIdDesktop}
                      autoplay={true}
                      muted={true}
                      showControls={false}
                      className={'pt-[55%] video-absolute'}
                      onPlayerInit={onPlayerInit}
                      loop={true}
                    />
                  </div>
                ) : (
                  <div className={`highlight_bg laptop:mb-7`}>
                    <div class="relative pb-[60.3%]">
                      <Image
                        src={imageDesktop}
                        className="w-full absolute top-0 left-0 h-full object-cover"
                        srcWidths={{
                          sm: 640,
                          md: 768,
                          lg: 1024,
                          xl: 1280,
                          '2xl': 1920,
                        }}
                      />
                    </div>
                  </div>
                )
              ) : videoIdMobile ? (
                <div className="highlight_video laptop:mb-7">
                  <Video
                    url={videoUrlMobile}
                    id={videoIdMobile}
                    autoplay={true}
                    muted={true}
                    showControls={false}
                    className={'pt-[53%]'}
                    onPlayerInit={onPlayerInit}
                    loop={true}
                  />
                </div>
              ) : (
                <div className={`highlight_bg laptop:mb-7`}>
                  <Image
                    src={imageMobile}
                    className="w-full"
                    srcWidths={{
                      sm: 640,
                      md: 768,
                      lg: 768,
                      xl: 768,
                      '2xl': 768,
                    }}
                  />
                </div>
              )}
            </div>
          </div>
        )}
      </>
    );
  };

  init();
};
